const WEBHOOK_URL = 'https://n8n.anysports.tv/webhook/search-queries'

/**
 * В тестах наружу не ходим: юнит-прогон не должен стучаться на живой n8n,
 * а e2e — засорять продуктовый сбор запросов мусорными данными.
 * Проверяем оба признака: в юнит-тестах NODE_ENV=test, а в e2e (.env.e2e)
 * NODE_ENV=production при VUE_APP_ID=test — одной проверки не хватило бы.
 *
 * Вынесено в экспортируемый объект, чтобы тесты могли подменить проверку:
 * присвоить process.env.NODE_ENV в тесте нельзя — webpack инлайнит его как
 * строковый литерал, и присваивание становится синтаксически невалидным.
 */
export const env = {
  isTest (): boolean {
    return process.env.NODE_ENV === 'test' || process.env.VUE_APP_ID === 'test'
  }
}

/**
 * Отправка поискового запроса в n8n — параллельно обычной аналитике.
 * Продукт собирает сырые запросы пользователей отдельным каналом
 * (эпик SEARCH-HOME: сигнал спроса).
 *
 * Отправка сознательно «в фон»: без await и с проглатыванием ошибок.
 * Внешний вебхук не должен ни задерживать выдачу, ни ронять поиск, если
 * n8n недоступен или отвечает ошибкой. keepalive — чтобы запрос дошёл,
 * даже если пользователь сразу уходит со страницы.
 */
export default class SearchQueriesWebhook {
  static send ({
    userId,
    email,
    query
  }: {
    userId: number | string;
    email: string;
    query: string;
  }): void {
    if (env.isTest()) return

    try {
      fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userID: String(userId),
          email,
          query
        }),
        keepalive: true
      }).catch(() => undefined)
    } catch {
      // Сеть/CSP/блокировщик — молча игнорируем: сбор запросов не критичен
      // для работы поиска.
    }
  }
}
